import { render, staticRenderFns } from "./ProductClass.vue?vue&type=template&id=1b3f42f6&functional=true"
import script from "./ProductClass.vue?vue&type=script&lang=js"
export * from "./ProductClass.vue?vue&type=script&lang=js"
import style0 from "./ProductClass.vue?vue&type=style&index=0&id=1b3f42f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports